import { styled } from '@/shared/ui';

export const StyledWrapper = styled('div')`
  height: 70%;
  display: flex;
`;

export const StyledBox = styled('div')`
  display: flex;
  align-items: center;
  gap: 100px;
  margin: auto;
`;

export const StyledText = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 30px;

  font-weight: 400;
  font-style: Regular;
  font-size: 45px;
`;
